module.exports = __webpack_public_path__ + "static/img/apple-store-badge-en-GB.600c9cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple-store-badge-en-GB.png
// module id = UunD
// module chunks = 1